import FlashcardPageItem from './FlashcardPageItem'
import FlashcardPageMetaData from './FlashcardPageMetaData'

class FlashcardPageClass{
    constructor(config={}){
        this.pageId = config.pageId || new Date().valueOf();
        this.pageSequence = config.pageSequence || 0;
        this.pageMetaData = FlashcardPageMetaData(config.pageMetaData);
        this.pageItems = this.initItem(config.pageItems);
        this.isNew = config.isNew || false;
    }

    initItem(itemCollection=[]){
        return itemCollection.map(FlashcardPageItem);
    }

    isQuiz(){
        return this.pageMetaData.isQuiz();
    }

    isUnanswered(ignoreNonMandatory){
        return this.pageMetaData.isQuiz() && 
            this.pageMetaData.questionResponse && 
            !this.pageMetaData.questionResponse.isAnswered()
            && (!ignoreNonMandatory || this.isMandatory());
    }

    isMandatory(){
        return this.pageMetaData.isMandatory();
    }
}


const FlashcardPage = config => new FlashcardPageClass(config);

FlashcardPage.getFontColor = (bgcolor,textColor) => { ///Returns the more contrasting color
    function luminanace(r, g, b) {
        var a = [r, g, b].map(function (v) {
            v /= 255;
            return v <= 0.03928
                ? v / 12.92
                : Math.pow( (v + 0.055) / 1.055, 2.4 );
        });
        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    }

    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? [parseInt(result[1], 16),parseInt(result[2], 16),parseInt(result[3], 16)] : [0,0,0];
    }

    var rgbForBg = [0,0,0];
    var rgbForFont = [0,0,0];
    if(bgcolor.startsWith('#') || textColor.startsWith('#')) {
        rgbForBg = hexToRgb(bgcolor);
        rgbForFont = hexToRgb(textColor);
    } else {
        rgbForBg = bgcolor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        rgbForFont = textColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    }
    if(rgbForBg && rgbForFont) {
        if ((luminanace(255, 255, 255) + 0.05) / (luminanace(rgbForFont[1], rgbForFont[2], rgbForFont[3]) + 0.05) > (luminanace(255, 255, 255) + 0.05) / (luminanace(rgbForBg[1], rgbForBg[2], rgbForBg[3]) + 0.05)) {
            return textColor;
        } else {
            return bgcolor;
        }
    } else {
        return textColor;
    }
}
export default FlashcardPage;